import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TarjetaEmpresa } from '../carga-empresas/interface/tarjeta-empresa.interface';
import { RegistroService } from '../registro.service';
@Injectable({
    providedIn: 'root',
})
export class CargaEmpresasService {
    private readonly apiUrl = environment.apiSiriUrl;
    constructor(
        private readonly http: HttpClient,
        private readonly registroService: RegistroService
    ) {}

    obtenerEmpresas(): Observable<TarjetaEmpresa[]> {
        return this.http.get<TarjetaEmpresa[]>(
            `${this.apiUrl}agente-vigilado/empresas`
        );
    }

    obtenerEmpresaSeleccionada(): Observable<string> {
        return this.obtenerEmpresas().pipe(
            map((empresasAsociadas) => {
                const empresaSeleccionadaId =
                    this.registroService.empresaSelected;
                const empresaEncontrada = empresasAsociadas.find(
                    (emp) => String(emp.id) === String(empresaSeleccionadaId)
                );
                return empresaEncontrada
                    ? empresaEncontrada.razonSocial
                    : 'Empresa';
            })
        );
    }
}
